module.exports = __webpack_public_path__ + "img/IMG_3119_L_Foamcore.cf6abce7.jpg";